import Multiselect from "./Multiselect.js";
import { withStyles } from "@material-ui/core";
import styles from "./styles.js";
import commonStyles from "../styles";
import combineStyles from "utils/combineStyles.js";

const combinedStyles = combineStyles(commonStyles, styles);

export default withStyles(combinedStyles)(Multiselect);
